import React, { useState } from "react";
import "./OfferSection.css";

const OfferSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: ""
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const courses = [
    "O-Level",
    "CCC (Course on Computer Concepts)",
    "ADCA (Advanced Diploma in Computer Applications)",
    "PGDCA (Post Graduate Diploma in Computer Applications)",
    "Tally & Communication",
    "Spoken English" 
  ];

  const notifications = [
    {
      id: 1,
      title: "NIELIT Courses",
      description: "Free courses available for OBC category students",
      link: "/nielit",
      colorClass: "blue",
      icon: "📚"
    },
    {
      id: 2,
      title: "UPSDM Project",
      description: "Skill development program - Free for OBC",
      link: "/upsdm",
      colorClass: "green",
      icon: "🎯"
    },
    {
      id: 3,
      title: "BSDM Initiative",
      description: "Bihar Skill Development Mission - Free admission",
      link: "/bsdm",
      colorClass: "purple",
      icon: "🚀"
    },
    {
      id: 4,
      title: "ASDC Program",
      description: "Automotive Skills Development Council - OBC Free",
      link: "/asdc",
      colorClass: "orange",
      icon: "⚙️"
    },
    {
      id: 5,
      title: "PMKVY Scheme",
      description: "Pradhan Mantri Kaushal Vikas Yojana - Free Training",
      link: "/pmkvy",
      colorClass: "red",
      icon: "💼"
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.mobile || !formData.course) {
      alert("Please fill all fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email");
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsSubmitting(true);

    try {
      console.log("Form submitted:", formData);
      await new Promise(resolve => setTimeout(resolve, 1500));
      alert("Registration successful! We'll contact you soon.");
      setFormData({
        name: "",
        email: "",
        mobile: "",
        course: ""
      });
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="offer-container">
      <div className="offer-content-wrapper">
        
        {/* Left Side - Notifications Card */}
        <div className="offer-notifications-section">
          <div className="notification-header-inline">
            <span className="notification-icon-inline">🔔</span>
            <div>
              <h3 className="notification-title-inline">Latest Updates</h3>
              <p className="notification-subtitle-inline">Free courses & schemes</p>
            </div>
          </div>
          
          <div className="notification-scroll-wrapper">
            <div className="notification-scroll-animate">
              {[...notifications, ...notifications].map((notif, index) => (
                <a
                  key={`${notif.id}-${index}`}
                  href={notif.link}
                  className="notification-card-inline"
                >
                  <div className="notification-card-inner-inline">
                    <div className={`notification-accent-inline ${notif.colorClass}`}></div>
                    <div className="notification-content-wrapper">
                      <div className={`notification-icon-box ${notif.colorClass}`}>
                        <span>{notif.icon}</span>
                      </div>
                      <div className="notification-text-content">
                        <h4 className="notification-title-text">{notif.title}</h4>
                        <p className="notification-description-text">{notif.description}</p>
                        <span className="notification-link-text">
                          View Details <span className="arrow">→</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
          
          <div className="notification-footer-inline">
            <p><span className="icon">🎓</span> Free courses for OBC students</p>
          </div>
        </div>

        {/* Right Side - Form Card */}
        <div className="offer-card">
          <div className="discount-badge">
            <p className="discount-percentage">30% OFF</p>
            <p className="discount-subtitle">Limited Time</p>
          </div>
          
          <div className="form-header">
            <h2>Special Offer</h2>
            <p className="form-subtitle">For New Students Only</p>
            <div className="form-divider"></div>
          </div>

          <form className="offer-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  required
                />
                <span className="input-icon">👤</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-wrapper">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="your.email@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  required
                />
                <span className="input-icon">📧</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="mobile">Mobile Number</label>
              <div className="input-wrapper">
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  placeholder="10-digit mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="[0-9]{10}"
                  disabled={isSubmitting}
                  required
                />
                <span className="input-icon">📱</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="course">Select Course</label>
              <div className="input-wrapper">
                <select
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  required
                >
                  <option value="">Choose your course</option>
                  {courses.map((course, index) => (
                    <option key={index} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
                <span className="input-icon">📚</span>
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Processing...
                </>
              ) : (
                <>
                  <span className="btn-icon">🚀</span>
                  Claim Your 30% Discount
                </>
              )}
            </button>

            <div className="trust-indicators">
              <div className="trust-item">
                <span>✓</span>
                <span>Instant Response</span>
              </div>
              <div className="trust-item">
                <span>🔒</span>
                <span>Secure</span>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};

export default OfferSection;